export default {
  primary: '#474a4f',
  secondary: '#ff5252'
};